import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { translate, toTitleCase, langUserGet } from './utils';
import { apiURIMain } from './apiConfig';
import Vue2Filters from 'vue2-filters';
import $router from './router';
import moment from 'moment'


// BootstrapVue
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Translation
Vue.filter('translate', translate);
Vue.filter('i18n', translate);
Vue.filter('i', translate);
Vue.filter('toTitleCase', toTitleCase);
Vue.filter('assetsImg', (imgName) => {
    console.log('assetsImg filter called with imgName:', imgName, `${$router.options.base}assets/img/${imgName}`);
    return `${$router.options.base}assets/img/${imgName}`;
});
Vue.use(Vue2Filters);

// Format MSISDN
Vue.filter('formatMSISDN', function (value) {
    if (!value || value.length !== 10) return value;
    return `(${value.substring(0, 2)}) ${value.substring(2, 6)}-${value.substring(6, 10)}`;
});
Vue.filter('imageIdToURL', function (value, attrs = {}) {
    const width = attrs.w || 400,
        height = attrs.h || 300;

    if (!value)
        return `https://placehold.co/${width}x${height}/b3cdbf/ffffff?text=No+Image`;

    if (attrs.w && attrs.h)
        return `${apiURIMain}img/render/${value}/${width}/${height}/rezied.jpg`;
    else
        return `${apiURIMain}img/render/${value}`;

});

// HAND MADE FILTERS
Vue.filter('humanize', (value) => {
	moment.locale(langUserGet() || 'en');
	// return moment(value).format("dddd D [de] MMMM");
	return moment(value).format("dddd D [de] MMMM [del] YYYY, h:mm:ss a");
});